import useIsMounted from 'ismounted'
import { useState, useEffect } from 'react'
import { MemberProfile } from 'types'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import { useQueryClient } from 'react-query'

export const useMemberProfile = (workspaceId: string | number | undefined, memberId: number | undefined) => {
  const isMounted = useIsMounted()
  const [profile, setProfile] = useState<MemberProfile>()
  const [error, setError] = useState(false)
  const queryClient = useQueryClient()
  // NOTICE: Profile is always a new object, and the compare is shallow
  //         Just using `profile` in the useEffect below was sending the app into a query loop
  const isProfileUndefined = !profile
  const isProfileMember = profile?.id === memberId

  useEffect(() => {
    if (workspaceId === undefined || memberId === undefined || isProfileMember) return

    if (isProfileUndefined) {
      queryClient.invalidateQueries(['memberProfile', workspaceId, memberId])
    }

    setError(false)

    queryClient.fetchQuery(
      ['memberProfile', workspaceId, memberId],
      async () => {
        const response = await client.getMemberProfile(workspaceId, memberId)
        if (response.type === SUCCESS_RESPONSE_TYPE) {
          if (isMounted.current) setProfile(response.data)
        } else {
          setError(true)
        }
      },
      { staleTime: 10000 },
    )

    return () => {
      queryClient.invalidateQueries(['memberProfile', workspaceId, memberId])
    }
  }, [workspaceId, memberId, isMounted, queryClient, isProfileMember, isProfileUndefined])

  return { profile, error }
}
